import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Tabs,
    Tab,
    Button,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
// import CardMembershipIcon from "@mui/icons-material/CardMembership";
import Description from "@mui/icons-material/Description";
import PrintIcon from "@mui/icons-material/Print";
import authService from "../Auth/AuthService";
// import { getAcademicYear } from "../utils/academicYear";
import { useLocation, useNavigate } from "react-router-dom";
import TransferCertificateState from "../reciept/TransferCertificateState";
import TransferCertificateCbse from "../reciept/TransferCertificateCbse";
import { printHtml } from "../utils/htmlToPrint";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function AnimatedTabPanel({ children, value, index }) {
    return (
        <AnimatePresence mode="wait">
            {value === index && (
                <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.4 }}
                >
                    <Box sx={{ p: 2 }}>{children}</Box>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export default function TransferCertificatePage({user}) {
    const location = useLocation();
    const receiptData = location.state || {};
    const student = receiptData.students;
    const [show, setShow] = useState(true);
    const [value, setValue] = useState(0);
    const [school, setSchool] = useState({});
    // const board = student?.classRoom[student?.classRoom.length - 1]?.patternType;

    const hasFetched = useRef(false);
    const [temID, setTemID] = useState(null);
    const navigate = useNavigate();
    const DOC_URL = authService.DOC_URL

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        console.log(student);
        loadSchool();
    }, []);

    const handleChange = (_, newValue) => setValue(newValue);

    const loadSchool = async () => {
        try {
            if (user?.mas_id !== undefined && user?.mas_id !== 'undefined') {
                const url = authService.pathUrl("GET", "/schools/" + user?.mas_id);
                const schoolsData = await authService.getAuth(url);
                const updatedForm = {
                    ...schoolsData,
                    logoUrl: DOC_URL + schoolsData.logoUrl
                };
                setSchool(updatedForm);
            }
        } catch (error) {
            console.error("Error fetching schools:", error);
        }
    }

    const tabs = [
        { icon: <Description />, label: "State T.C." },
        { icon: <Description />, label: "SBSE T.C." },
        // { icon: <CardMembershipIcon />, label: "Entry Card" },
    ];

    // const handlePrint = () => {
    //     setShow(false);
    //     setTimeout(() => {
    //         window.print();
    //         setShow(true);
    //     }, 100);
    // };

    const handleBack = () => {
        navigate(-1)
    };

    // const handleDelete = async () => {
    //     const url = authService.pathUrl('DELETE', `/students/${student.id}`);
    //     await authService.deleteAuth(url);
    // }

    return (
        <Box sx={{ width: "100%", py: 3, backgroundColor: "#fafafa", minHeight: "100vh" }}>

            {show && (<>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    // centered
                    //variant="fullWidth"
                    textColor="#3f2d01"
                    indicatorColor="secondary"
                    slotProps={{
                        indicator: {
                            sx: {
                                backgroundColor: "#ff9800",
                                height: "3px",
                                borderRadius: "2px",
                                transition: "background-color 0.3s ease",
                            },
                        },
                    }}
                    sx={{
                        mb: 3,
                        "& .MuiTab-root": {
                            textTransform: "none",
                            fontWeight: "bold",
                            flexDirection: "row",
                            gap: 1,
                        },
                    }}
                >
                    {tabs.map((tab, i) => (
                        <Tab
                            key={i}
                            icon={
                                <motion.div
                                    animate={{
                                        scale: value === i ? 1.5 : 1,
                                        color: value === i ? "#3f2d01" : "#757575",
                                    }}
                                    transition={{ type: "spring", stiffness: 300 }}
                                >
                                    {tab.icon}
                                </motion.div>
                            }
                            label={tab.label}
                            iconPosition="start" // 👈 keeps icon + label side-by-side
                        />
                    ))}
                </Tabs>
                <Box position={'absolute'} right={20} top={40}>
                    <Button variant="outlined" sx={{ bgcolor: '#3f2d01', color: '#fff' }} startIcon={<ArrowBackIcon />} onClick={handleBack}>
                        Back
                    </Button>
                </Box>
            </>)}

            {receiptData && (<>
                {/* //  Tab 1: state board tc */}
                <AnimatedTabPanel value={value} index={0}>
                    <TransferCertificateState student={student} school={school} setTemID={setTemID} />
                </AnimatedTabPanel>

                {/* //  Tab 2: cbse board tc */}
                <AnimatedTabPanel value={value} index={1}>
                    <TransferCertificateCbse student={student} school={school} setTemID={setTemID} />
                </AnimatedTabPanel>

                {/* //  Tab 3: entry card */}
                {/* <AnimatedTabPanel value={value} index={2}>
                    <EntryCard receiptData={receiptData} school={school} />
                </AnimatedTabPanel> */}

                {show && (
                    <Box sx={{ textAlign: "center", mt: 3 }}>
                        <Button variant="outlined" sx={{ color: "#3f2d01" }} startIcon={<PrintIcon />} onClick={() => { printHtml(temID); window.location.reload() }}>
                            Print Now
                        </Button>
                    </Box>
                )}
            </>)}
        </Box>
    );
}